import { type IAICallingType } from 'entities/AICalling/api/types'
import { ChatbotRoutes } from './type'

const chatbot = `${ChatbotRoutes.root}`
const chatbotNew = `${chatbot}/${ChatbotRoutes.new}`
const chatbotAnalytic = `${chatbot}/${ChatbotRoutes.analytic}`
const agentNewBookAppointment = `${chatbotNew}/${ChatbotRoutes.steps}`

export const ChatbotPath = {
  root: chatbot,
  all: `${chatbot}/${ChatbotRoutes.all}`,
  texting: `/${chatbot}/${ChatbotRoutes.texting}`,
  calling: `/${chatbot}/${ChatbotRoutes.calling}`,
  callingNew: (type: IAICallingType) =>
    `/${chatbot}/${ChatbotRoutes.calling}/${ChatbotRoutes.new}?type=${type}`,
  callingEdit: (id: number) => `/${chatbot}/${ChatbotRoutes.calling}/${ChatbotRoutes.edit}/${id}`,
  callingView: (id: number) => `/${chatbot}/${ChatbotRoutes.calling}/${ChatbotRoutes.view}/${id}`,
  new: chatbotNew,
  edit: (id: number) => `/${chatbot}/${id}`,
  newChat: `/${chatbotNew}/${ChatbotRoutes.chat}`,
  newConfig: `/${chatbotNew}/${ChatbotRoutes.config}`,
  editChat: (id: number) => `/${chatbot}/${id}/${ChatbotRoutes.chat}`,
  editConfig: (id: number) => `/${chatbot}/${id}/${ChatbotRoutes.config}`,
  newBookAppointment: agentNewBookAppointment,
  viewBookAppointment: (id: number) => `${chatbot}/${id}/${ChatbotRoutes.steps}`,
  analytic: chatbotAnalytic,
}
